import { AutoAwesome as AutoAwesomeIcon } from '@mui/icons-material';
import { Box, Button, CircularProgress } from '@mui/material';
import React from 'react';

interface TableMobileViewActionsProps {
  isDraft: boolean;
  hasSaved: boolean;
  busy: boolean;
  confirmDraft: () => void;
  discardDraft: () => void;
  remove: () => void;
  generate: () => void;
}

/** Draft / saved / automatic-layout action buttons for the Table mobile-view preview. */
export default function TableMobileViewActions({
  isDraft,
  hasSaved,
  busy,
  confirmDraft,
  discardDraft,
  remove,
  generate,
}: TableMobileViewActionsProps) {
  return (
    <Box sx={{ display: 'flex', gap: 1, mt: 1.5 }}>
      {isDraft ? (
        <>
          <Button size="small" variant="contained" onClick={confirmDraft}>
            Use this mobile view
          </Button>
          <Button size="small" onClick={generate} disabled={busy}>
            Regenerate
          </Button>
          <Button size="small" color="inherit" onClick={discardDraft}>
            Discard
          </Button>
        </>
      ) : hasSaved ? (
        <>
          <Button size="small" onClick={generate} disabled={busy}>
            Regenerate with AI
          </Button>
          <Button size="small" color="error" onClick={remove}>
            Remove mobile view
          </Button>
        </>
      ) : (
        <Button
          size="small"
          variant="outlined"
          startIcon={busy ? <CircularProgress size={14} /> : <AutoAwesomeIcon fontSize="small" />}
          onClick={generate}
          disabled={busy}
        >
          Refine with AI
        </Button>
      )}
    </Box>
  );
}
